// extracted by mini-css-extract-plugin
export default {"container":"tab-component_container__TjR+2","truncate-table":"tab-component_truncate-table__Od-+G","table-text-faded":"tab-component_table-text-faded__uC6RJ","tabComponent":"tab-component_tabComponent__-NSuq","tabs":"tab-component_tabs__KajYs","tabItem":"tab-component_tabItem__8-Ql2","isSelected":"tab-component_isSelected__zm7j1"};
    if(module.hot) {
      // 1793877089505
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  